import { Accordion as MuiAccordion, AccordionProps, styled, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTween } from 'react-use';
import { AdaptiveTypography, Button, Typography } from '../../components/base';
import { EXTERNAL_LINKS } from '../../helpers/constant';
import { AppContext } from '../../helpers/hooks/AppContext';
import style from './checkinQuestions.module.scss';
import 'react-multi-carousel/lib/styles.css';
import "./carouselOverride.css"


import  { DaburScores } from '../../helpers/abTest';
import { daburQuestionaire } from './selfCheckinQuestionaireDabur.page';



const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,

  '&::before': {
    display: 'none',
  },
}));

const CheckinSummaryCorporate = () => {

  const theme = useTheme();
  const isTwoColumn = useMediaQuery(theme.breakpoints.up('sm'));
  const [score, setScore] = useState<any>(0);
  const [maxscore, setmaxscore] = useState(0)
  const navigate = useNavigate();
  const tween = useTween('outCubic', 700);

  const [pageTime, _] = useState(new Date())
  const [clickedVideo, __] = useState<any>({})

  const onReview = () => {

  }
  const { mixpanel } = useContext(AppContext);

  const [expandedQuestion, setExpandedQuestion] = useState<any>(null)
  const [aspectRatio, setAspectRatio] = useState<any>(null);

  const playerRef = useRef<any>(null);

  const testimonials = [
    {
      title: 'Best decision of my life',
      content: 'It was one of the best decision of my life to go with Mitsu.care. It helped me alot during tough phase in my life. My therapist Vidula was blessing for me.She guided me in this throughout journey. Mitsu not only helps us during difficult times also it teaches us skills to upgrade in daily life challenges. Thank u Mitsu.care and Vidula.',
      user: 'Varsha Kulkarni',
      platform: 'Rated ⭐⭐⭐⭐⭐ on Google Play Store'
    },
    {
      title: 'Wanted to feel better … Mitsu delivered',
      content: 'I wanted a way to feel better that was scientific but that I could do myself, and Mitsu delivered. The videos are top notch. And being able to chat with a psychologist to clear my doubts helped me feel a lot more grounded, much more quickly than muddling through alone.',
      user: 'Rohan Jaikishen',
      platform: 'Rated ⭐⭐⭐⭐⭐ on Google Play Store'
    },
    {
      title: 'Empowers you to self-heal',
      content: 'Undoubtedly the one of the best decision I made in life was spending on this app for my wellbeing. It empowers u to self heal with a expert. (In my case indebted to ms. RAKSHA) she has given that soft nudge wen need and always a lot of kind words. And a loads of patience to hear me out. Wen no one was there. .. (mind u it not easy to come out and seek help) . She made me to DO the WORK. .',
      user: 'Lakshmi',
      platform: 'Rated ⭐⭐⭐⭐⭐ on Google Play Store'
    },
    {
      title: 'Lives up to the promise',
      content: 'I found myself in a downward spiral when someone told me to take this up ! Not only has this helped me stop the spiral , but it has got me back to life and may be even more ! Lives up to the promise with an extremely caring team to ensure my well being . The team has gone out of their way to show care and concern Highly recommended for everyone to take this course ❤️',
      user: 'Varun',
      platform: 'Rated ⭐⭐⭐⭐⭐ on Google Play Store'
    },
    {
      title: 'Helping me become a better version of me',
      content: 'Mitsu care is helping me become a better version of me. Clearly a lot of care and thought has gone into building the app. The lessons don\'t feel rushed. I can take them on the go. They know the difference between reading about and putting the skills to use they\'ve given time to soak it all in. My favorite part of the journey though has been the constant check-ins with their therapist. Yes I signed up to help myself, but it really helped to have a trained and empathetic counsellor nudge me along and explain a lesson to me in MY context, when I got stuck. Go on, give mitsu care a shot and download it - one of the best gifts you can give yourself.',
      user: 'Srishti',
      platform: 'Rated ⭐⭐⭐⭐⭐ on The App Store'
    },
  ]


  const FAQS = [

    //Check-in score page FAQs
    {
      question: 'What are the next steps for me?',
      answer: `Your next step is to choose a plan that suits you best— either the full program or a 1-week trial. After that, you'll schedule a call with a Mitsu therapist, who will discuss your concerns and mental health goals and create a personalized program just for you.`
    },
    {
      question: 'What does my score mean?',
      answer: `Your scores measure symptoms of anxiety and depression, which are good indicators of your overall mental health. Essentially, they reveal which parts of life you may be struggling with and how distressing you find these struggles. 

You can think of this assessment as a thermometer. A higher score, just like a higher body temperature, means you’re likely struggling inside. Watch the video above to learn more about your scores and understand how you can feel better!`,
    },
    {
      question: 'What is the Mood Check-in based on? Is it reliable?',
      answer: `Mitsu’s Mood Check-in is based on the PHQ-9 and the GAD-7, two gold-standard assessments of depression and anxiety symptoms respectively. They are used by clinicians all over the world to gauge mental health.`,
    },

  ]

  useEffect(() => {
    const getCheckInSummary = async () => {

      let score = 0;
      let maxscore = 0
      for(let question of daburQuestionaire){
        if(question.scoring){
          maxscore+=5
          let data = localStorage.getItem(`Q-1-${question.id}`)
          if(data){
            let answers = JSON.parse(data)
            if(answers instanceof Array){
              let scoreKey = Object.keys(question.options).find((q)=>q==answers.at(0))
              let cscore = (question.options as any)[scoreKey as any] 
              score+=cscore
            }
          }
        }
      }
      setmaxscore(maxscore)
      setScore(score);
    };
    getCheckInSummary();

  }, []);

  let scoreCat = DaburScores.at(0)

  for(let cat of DaburScores){
    if(score>=cat.scoreRange.at(0)! && score<=cat.scoreRange.at(1)!){
      scoreCat = cat;
      break;
    }
  }
  
  return (
    <div className={style.questionsPageContainer}>
      <div className={style.questionsPageCenter}>
        <div className={style.questionsPage}>
          <div className={`${style.summaryHeader} `}>
            <AdaptiveTypography variant="h2" mobileVariant="h3" className={`${style.summaryHeader}  ${isTwoColumn ? '' : style.alignJustify}`}>
              Your Check-in Summary
            </AdaptiveTypography>
            <div className={`${style.summaryGroup} ${isTwoColumn ? style.col_2 : style.col_1}`}>
              <div  className={style.summaryResultBox}>

                <Typography variant="label" className={style.scoreSuggests}>
                  {' '}
                  {scoreCat!.scoreRange.length > 1 && scoreCat!.scoreRange[1]
                    ? `A score between ${scoreCat!.scoreRange[0]} to ${scoreCat!.scoreRange[1]} suggests`
                    : `A score of ${scoreCat!.scoreRange[0]} or above suggests`}{' '}
                </Typography>
                <AdaptiveTypography variant="h3" mobileVariant="h2mid" className={style.summaryCategoryTitle}>
                  {scoreCat!.level}
                </AdaptiveTypography>

                <div className={style.summaryProgressBarContainerBox}>
                  <AdaptiveTypography className={style.summaryProgressBarLegend}>
                    0
                  </AdaptiveTypography>
                  <div className={style.summaryProgressBarContainer}>
                    <div className={style.summaryProgressBarBottom} />
                    <div
                      className={style.summaryProgressBarTop}
                      style={{
                        width: `${(score * 100) / maxscore}%`,
                        backgroundSize: `${(maxscore / score) * 100}%`
                      }}
                    />
                    <div className={style.summaryProgressBarHighlight} />
                    <div className={style.summaryProgressBarHighlightCircle} />

                  </div>
                  <AdaptiveTypography className={style.summaryProgressBarLegend}>
                    {maxscore}
                  </AdaptiveTypography>


                  <AdaptiveTypography
                    className={`${style.scoreText}`}
                    variant="h3"
                    mobileVariant="h1"
                  >
                    {`${score}/${maxscore}`}
                  </AdaptiveTypography>

                </div>



                <div className={style.summaryResultContent}>
                    <AdaptiveTypography
                        variant="subheading3"
                        mobileVariant="subheading1"
                        className={style.summaryCategoryDescription}
                    >
                      {
                        scoreCat!.text
                      }
                    </AdaptiveTypography>
                </div>
                </div>
            </div>
          </div>

          <div className={style.spaceStandard}></div>

          <div className={style.buttonRow}>
            <Button variant='contained' onClick={()=>{}}>
              Go to next step
            </Button>
          </div>
              <div style={{ height: '20px' }} ></div>
          <div onClick={onReview} className={style.reviewResponse}>Review your responses</div>
          


          <div className={style.noteBox}>
            <Typography variant='h4' className={`${style.noteHeader} ${style.alignJustify}`} >Note</Typography>
            <AdaptiveTypography variant='subheading3' mobileVariant='body' className={`${style.alignJustify}`} >
              <span className={style.noteText} >The depression and anxiety symptoms scores calculated here are based on the PHQ-9 and GAD-7 questionnaires from the PRIME-MD. The PHQ-9 simply scores each of the nine DSM-IV criteria based on the mood module on a scale of 0-27. The GAD-7 scores seven common anxiety symptoms on a scale of 0-21. Please note that these questionnaires cannot be used as replacement for clinical assessment, and additional evaluation should be used to confirm diagnosis for any depressive or anxiety related disorders. Read more about these here: <a className={style.external_link} target='_blank' href={EXTERNAL_LINKS.phq_9}>PHQ-9,</a> <a className={style.external_link} target='_blank' href={EXTERNAL_LINKS.gad_7} >GAD-7</a></span>
            </AdaptiveTypography>
          </div>

          <div className={style.spacer} />
          <div style={{ height: '40px' }} />
        </div>
      </div >
    </div >
  );
}


const CustomDot = ({ onClick, ...rest }: any) => {
  const {
    index,
    active,
  } = rest;
  // onMove means if dragging or swiping in progress.
  return (
    <div
      className={`${style.carouselIndicator} ${active ? style.indicatorSelected : ""}`}
      onClick={() => onClick()}
    >
    </div>
  );
};

const CustomLeftArrow = ({ onClick, ...rest }: any) => {
  const {
    onMove,
  } = rest;
  // onMove means if dragging or swiping in progress.
  return <button onClick={onClick} className={style.caouselLeftArrow} ></button>;
};

const CustomRightArrow = ({ onClick, ...rest }: any) => {
  const {
    onMove,
  } = rest;
  // onMove means if dragging or swiping in progress.
  return <button onClick={onClick} className={style.caouselRightArrow} ></button>;
};


export default CheckinSummaryCorporate;
